import SessionStorageProvider from 'libs/providers/session-storage-provider';
import { catchError, map, Observable } from 'rxjs';
import Session from '../models/session';

class SessionProvider {
  static keyName = 'token';

  constructor(
    public provider: SessionStorageProvider = new SessionStorageProvider(),
  ) {}

  get = (): Observable<Session> => {
    return this.provider.get(SessionProvider.keyName).pipe(
      map((sessionString) => JSON.parse(sessionString as string)),
      map((sessionJson) => new Session().fromJSON(sessionJson)),
      catchError((error) => {
        throw Error('Error, no existe token');
      }),
    );
  };

  getToken = (): Observable<string> => {
    return this.provider.get(SessionProvider.keyName).pipe(
      map((token) => `Bearer ${token}`),
      catchError((error) => {
        throw Error('Error, no existe token');
      }),
    );
  };

  save = (session: Session) => {
    if (!session.token) throw Error('Error, no existe token');
    this.provider.set(
      SessionProvider.keyName,
      JSON.stringify(session.toJSON()),
    );
  };

  remove = () => {
    this.provider.remove(SessionProvider.keyName);
  };
}

export default SessionProvider;
